import { render } from "./ThumbsUpIcon.vue?vue&type=template&id=a8669f60"
import script from "./ThumbsUpIcon.vue?vue&type=script&lang=js"
export * from "./ThumbsUpIcon.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/macallan-007.blooq-staging.com/releases/20230221094153/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__